import script from "./Chapter.vue?vue&type=script&setup=true&lang=ts"
export * from "./Chapter.vue?vue&type=script&setup=true&lang=ts"

import "./Chapter.vue?vue&type=style&index=0&id=56c3c722&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c3c722"]])

export default __exports__